import './App.css';

import { useState, useRef, useEffect } from 'react';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { AppContext } from './scripts/context'

import Header from './components/header'
import Footer from './components/footer'
import Page from './components/page'
import Error from './components/error'
import Privacy from './components/privacy'
import Scrollbar from './components/scrollbar'
import Checkout from './components/checkout'
import Widget from './components/widget'

function App() {
//REFS AND STATES INIT
    //GENERAL
    const pageElementsRefs = {
        mainContainerContent: useRef(null),
        bodyElement: useRef(document.getElementsByTagName("body")[0])
    };
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    //DEVICE OS DETECTION
    //const isAndroidRef = useRef(/Android/.test(navigator.userAgent));
    //const isIOSRef = useRef(/iPhone|iPad|iPod/.test(navigator.userAgent));
    const isAndroidPhoneRef = useRef(/Android/.test(navigator.userAgent) && /Mobile/.test(navigator.userAgent));
    const isIOSPhoneRef = useRef(/iPhone|iPod/.test(navigator.userAgent));
    //APP DETECTION
    const isAndroidAppRef = useRef(navigator.userAgent.toLowerCase().includes("njb.design.android.app"));
    //MENU
    const menuExpandedRef = useRef(true);
    const menuRunningRef = useRef(false);
    const menuLockedRef = useRef(false);
    const menuElementsRefs = {
        pathHome: useRef(null),
        circleHome0: useRef(null),
        circleHome1: useRef(null),
        dotHome: useRef(null),
        textHomeH: useRef(null),
        textHomeO: useRef(null),
        textHomeM: useRef(null),
        textHomeE: useRef(null),
        linkHome: useRef(null),
        pathDigital: useRef(null),
        circleDigital0: useRef(null),
        circleDigital1: useRef(null),
        dotDigital: useRef(null),
        textDigitalD: useRef(null),
        textDigitalI0: useRef(null),
        textDigitalG: useRef(null),
        textDigitalI1: useRef(null),
        textDigitalT: useRef(null),
        textDigitalA: useRef(null),
        textDigitalL: useRef(null),
        linkDigital: useRef(null),
        pathGames: useRef(null),
        circleGames0: useRef(null),
        circleGames1: useRef(null),
        dotGames: useRef(null),
        textGamesG: useRef(null),
        textGamesA: useRef(null),
        textGamesM: useRef(null),
        textGamesE: useRef(null),
        textGamesS: useRef(null),
        linkGames: useRef(null),
        pathDesign: useRef(null),
        circleDesign0: useRef(null),
        circleDesign1: useRef(null),
        dotDesign: useRef(null),
        textDesignD: useRef(null),
        textDesignE: useRef(null),
        textDesignS: useRef(null),
        textDesignI: useRef(null),
        textDesignG: useRef(null),
        textDesignN: useRef(null),
        linkDesign: useRef(null),
        pathStore: useRef(null),
        circleStore0: useRef(null),
        circleStore1: useRef(null),
        dotStore: useRef(null),
        textStoreS: useRef(null),
        textStoreT: useRef(null),
        textStoreO: useRef(null),
        textStoreR: useRef(null),
        textStoreE: useRef(null),
        linkStore: useRef(null),
        buttonMenu: useRef(null),
        menuBg: useRef(null)
    };
    //CONTACT CONTAINER
    const contactContainerStatusRef = useRef(false);
    const contactContainerRunningRef = useRef(false);
    const [contactButtonArrowState, setContactButtonArrowState] = useState(false);
    //WIDGET
    const [widgetState, setWidgetState] = useState(false);
    //CHECKOUT PANEL
    const exRateChfUsdRef = useRef(1);
    const cartItemLimitRef = useRef(25);
    const [cartContent, setCartContent] = useState(JSON.parse(localStorage.getItem("cartContent")));
    const [checkoutPanelState, setCheckoutPanelState] = useState(false);
    const [checkoutPanelContentState, setCheckoutPanelContentState] = useState("cart");
    const [checkoutPanelCountryState, setCheckoutPanelCountryState] = useState("select_country");
    const [checkoutPanelButtonState, setCheckoutPanelButtonState] = useState(!cartContent ? false : true);
    const [paypalSuccessState, setPaypalSuccessState] = useState(false);
    const [shippingCostState, setShippingCostState] = useState(0);
    const [cartDutyState, setCartDutyState] = useState(0);
    //SCROLL
    const [scrollButtonState, setScrollButtonState] = useState(true);
    const [scrollbarState, setScrollbarState] = useState(true);
    const scrollPrevPosRef = useRef();
    const contentHeight = useRef();
    //DETAIL
    const detailMediaLoadedRef = useRef(false);
    const detailItemActiveRef = useRef();
    const [detailMediaLoaderState, setDetailMediaLoaderState] = useState(false);
    const [detailWidgetState, setDetailWidgetState] = useState(false);

//STYLE INIT
    //WIDGET
    const getWidgetStyle = () => ({
        position: "fixed",
        width: "100%",
        height: isAndroidAppRef.current === true ? "calc(var(--vh, 1vh) * 100)" : "100lvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none"
    });
    const [widgetStyleState] = useState(getWidgetStyle);
    //WIDGET CONTAINER
    const getWidgetContainerStyle = () => ({
        position: "absolute",
        width: "100%",
        height: isAndroidAppRef.current === true ? "calc(var(--vh, 1vh) * 100)" : "100lvh",
        top: 0,
        pointerEvents: "none"
    });
    const [widgetContainerStyleState] = useState(getWidgetContainerStyle);
    //MAIN CONTAINER
    const getMainContainerStyle = () => ({
        position: "absolute",
        width: isAndroidAppRef.current === true ? "calc(var(--vw, 1vw) * 100)" : "100vw",
        height: isAndroidAppRef.current === true ? "calc(var(--vh, 1vh) * 100)" : "100lvh",
        visibility: getMainContainerVisibility()
    });
    const [mainContainerStyleState, setMainContainerStyleState] = useState(getMainContainerStyle);
    //MAIN CONTAINER CONTENT
    const getMainContainerContentStyle = () => ({
        position: "relative",
        width: isAndroidAppRef.current === true ? "calc(var(--vw, 1vw) * 100)" : "100vw",
        paddingTop: isAndroidAppRef.current === true ? "calc(var(--vh, 1vh) * 100)" : "100lvh",
        paddingBottom: isAndroidAppRef.current === true ? "calc(var(--vh, 1vh) * 100)" : "100lvh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        clipPath: "url(#fade_path)",
        backgroundColor: "#000000cc"
    });
    const [mainContainerContentStyleState] = useState(getMainContainerContentStyle);
    //MEDIA CONTAINER
    const [mediaContainerOpacityState, setMediaContainerOpacityState] = useState(getMediaContainerOpacity());
    const [mediaContainerVisibilityState, setMediaContainerVisibilityState] = useState(getMediaContainerVisibility());
    //MEDIA
    const getMediaStyle = () => ({
        position: "fixed",
        width: isAndroidAppRef.current === true ? "calc(var(--vw, 1vw) * 100)" : "100vw",
        height: isAndroidAppRef.current === true ? "calc(var(--vh, 1vh) * 100)" : "100lvh",
        objectFit: "cover",
        objectPosition: "50% 50%"
    });
    const [mediaStyleState] = useState(getMediaStyle);
    //MEDIA LOADER CONATINER
    const getMediaLoaderContainerStyle = () => ({
        position: "fixed",
        width: isAndroidAppRef.current === true ? "calc(var(--vw, 1vw) * 100)" : "100vw",
        height: isAndroidAppRef.current === true ? "calc(var(--vh, 1vh) * 100)" : "100lvh",
        backgroundColor: "#000000",
        visibility: "visible",
        opacity: 1
    });
    const [mediaLoaderContainerStyleState, setMediaLoaderContainerStyleState] = useState(getMediaLoaderContainerStyle);
    //SCROLLBAR
    const getScrollbarStyle = () => ({
        position: "fixed",
        width: "5px",
        height: isAndroidAppRef.current === true ? "calc(var(--vh, 1vh) * 100)" : "100lvh",
        right: 0,
        top: 0
    });
    const [scrollbarStyleState] = useState(getScrollbarStyle);
    //SCROLLBAR SLIDER
    const getScrollbarSliderStyle = () => ({
        position: "fixed",
        right: "0",
        width: "5px",
        height: getScrollbarSliderHeight(),
        transform: getScrollbarSliderTransform(),
        backgroundColor: "#333333",
        borderTopLeftRadius: "5px",
        borderBottomLeftRadius: "5px",
        transition: "transform 0.05s",
        willChange: "transform"
    });
    const [scrollbarSliderStyleState, setScrollbarSliderStyleState] = useState(getScrollbarSliderStyle);
    //CHECKOUT PANEL
    const getCheckoutPanelStyle = () => ({
        position: "fixed",
        width: "100%",
        height: isAndroidAppRef.current === true ? "calc(var(--vh, 1vh) * 100)" : "100lvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "safe center",
        flexDirection: "column",
        top: 0,
        left: 0,
        backgroundColor: "#000000cc",
        backdropFilter: "blur(4px)",
        overflow: "auto",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        overscrollBehavior: "none"
    });
    const [checkoutPanelStyleState] = useState(getCheckoutPanelStyle);
    //CHECKOUT PANEL COUNTRY OVERLAY
    const getCheckoutPanelCountryOverlayStyle = () => ({
        display: "flex",
        width: "100%",
        height: isAndroidAppRef.current === true ? "calc(var(--vh, 1vh) * 30)" : "30lvh",
        alignItems: "center",
        flexDirection: "column",
        backgroundColor: "#00000066",
        backdropFilter: "blur(4px)",
        zIndex: 1,
        borderTop: "2px solid #333333",
        borderBottom: "2px solid #333333",
        borderRadius: "7px",
        boxShadow: "2px 2px 5px 0 rgba(0,0,0,.5)",
        overflow: "auto",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        overscrollBehavior: "none",
        userSelect: "none"
    });
    const [checkoutPanelCountryOverlayStyleState] = useState(getCheckoutPanelCountryOverlayStyle);
    //DETAIL CONTAINER
    const getDetailContainerStyle = () => ({
        position: "absolute",
        width: "100%",
        height: isAndroidAppRef.current === true ? "calc(var(--vh, 1vh) * 100)" : "100lvh",
        top: 0
    });
    const [detailContainerStyleState] = useState(getDetailContainerStyle);
    //DETAIL PLAY BUTTON SVG
    const getDetailPlayButtonSvgStyle = () => ({
        position: "fixed",
        width: "96px",
        height: "96px",
        bottom: isAndroidAppRef.current === true ? "calc(var(--vh, 1vh) * 50 - 48px)" : "calc(50lvh - 48px)",
        left: isAndroidAppRef.current === true ? "calc(var(--vw, 1vw) * 50 - 48px)" : "calc(50vw - 48px)"
    });
    const [detailPlayButtonSvgStyleState] = useState(getDetailPlayButtonSvgStyle);
    //DETAIL WIDGET
    const getDetailWidgetStyle = () => ({
        position: "fixed",
        width: "100%",
        height: isAndroidAppRef.current === true ? "calc(var(--vh, 1vh) * 100)" : "100lvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none"
    });
    const [detailWidgetStyleState] = useState(getDetailWidgetStyle);
    //ITEMS CONTAINER CONTENT
    const getItemsContainerContentStyle = () => ({
        maxWidth: "min-content",
        display: "flex",
        flexDirection: "row",
        gap: "32px",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingLeft: isAndroidAppRef.current === true ? "calc(var(--vw, 1vw) * 50)" : "50vw",
        paddingRight: isAndroidAppRef.current === true ? "calc(var(--vw, 1vw) * 50)" : "50vw"
    });
    const [itemsContainerContentStyleState] = useState(getItemsContainerContentStyle);
    //DETAIL MEDIA TOP
    const getDetailMediaTopStyle = () => ({
        position: "fixed",
        width: "100%",
        height: isAndroidAppRef.current === true ? "calc(var(--vh, 1vh) * 100)" : "100lvh",
        objectFit: "cover",
        opacity: 1
    });
    const [detailMediaTopStyleState, setDetailMediaTopStyleState] = useState(getDetailMediaTopStyle);
    //DETAIL MEDIA BOTTOM
    const getDetailMediaBottomStyle = () => ({
        position: "fixed",
        width: "100%",
        height: isAndroidAppRef.current === true ? "calc(var(--vh, 1vh) * 100)" : "100lvh",
        objectFit: "cover"
    });
    const [detailMediaBottomStyleState, setDetailMediaBottomStyleState] = useState(getDetailMediaBottomStyle);
    //CHECKOUT PANEL SVG
    const getCheckoutPanelSvgStyle = () => ({
        position: "fixed",
        top: getDynamicCssValue(-10),
        right: getDynamicCssValue(-10),
        width: getDynamicCssValue(320.25, 300),
        height: "auto"
    });
    const [checkoutPanelSvgStyleState, setCheckoutPanelSvgStyleState] = useState(getCheckoutPanelSvgStyle);
    //SCROLL BUTTON SVG
    const getScrollButtonSvgStyle = () => ({
        position: "fixed",
        bottom: "0px",
        right: "0px",
        width: getDynamicCssValue(120),
        height: "auto"
    });
    const [scrollButtonSvgStyleState, setscrollButtonSvgStyleState] = useState(getScrollButtonSvgStyle);
    //TITLE CONTAINER
    const getTitleContainerStyle = () => ({
        position: "fixed",
        fontWeight: "normal",
        textAlign: "right",
        bottom: getDynamicCssValue(65),
        right: getDynamicCssValue(28),
        textShadow: "1px 1px 1px #00000080",
        visibility: getTitleContainerVisibility(),
        opacity: getTitleContainerOpacity()
    });
    const [titleContainerStyleState, setTitleContainerStyleState] = useState(getTitleContainerStyle);
    //TITLE TEXT
    const getTitleTextStyle = () => ({
        fontSize: getDynamicCssValue(18),
    });
    const [titleTextStyleState, setTitleTextStyleState] = useState(getTitleTextStyle);
    //BUTTON READ MORE
    const getButtonReadMoreStyle = () => ({
        marginTop: "0.5em",
        textDecoration: "underline",
        fontSize: getDynamicCssValue(14, 18)
    });
    const [buttonReadMoreStyleState, setButtonReadMoreStyleState] = useState(getButtonReadMoreStyle);
    //CONTACT CONTAINER
    const getContactContainerStyle = () => ({
        position: "fixed",
        bottom: contactContainerStatusRef.current ? getContactContainerOffsetExpanded() + "px" : getContactContainerOffsetCollapsed() + "px",
        left: getDynamicCssValue(-5.77),
        width: getDynamicCssValue(527.77),
        height: getIsMobile() === true ? "auto" : "308px",
        pointerEvents: "none",
    });
    const [contactContainerStyleState, setContactContainerStyleState] = useState(getContactContainerStyle);
    //CONTACT DETAILS
    const getContactDetailsStyle = () => ({
        position: "absolute",
        top: getDynamicCssValue(54),
        left: getDynamicCssValue(26),
        textAlign: "left",
    });
    const [contactDetailsStyleState, setContactDetailsStyleState] = useState(getContactDetailsStyle);
    //CONTACT TITLE
    const getContactTitleStyle = () => ({
        position: "absolute",
        top: getDynamicCssValue(16, 18),
        left: getDynamicCssValue(71),
        fontSize: getDynamicCssValue(14),
        textAlign: "left",
        userSelect: "none",
        pointerEvents: "none",
    });
    const [contactTitleStyleState, setContactTitleStyleState] = useState(getContactTitleStyle);
    //CONTACT TEXT
    const getContactTextStyle = () => ({
        position: "relative",
        color: "#FFFFFF",
        fontSize: getDynamicCssValue(12, 10),
        textDecoration: "none",
        userSelect: "text",
        pointerEvents: "auto"
    });
    const [contactTextStyleState, setContactTextStyleState] = useState(getContactTextStyle);
    //CONTACT TEXT TITLE
    const getContactTextTitleStyle = () => ({
        position: "relative",
        marginBottom: getDynamicCssValue(16),
        fontSize: getDynamicCssValue(20),
        userSelect: "text",
        pointerEvents: "auto"
    });
    const [contactTextTitleStyleState, setContactTextTitleStyleState] = useState(getContactTextTitleStyle);
    //CONTACT TEXT MEDIUM
    const getContactTextMediumStyle = () => ({
        position: "relative",
        color: "#FFFFFF",
        marginBottom: getDynamicCssValue(16),
        fontSize: getDynamicCssValue(16),
        textDecoration: "none",
        userSelect: "text",
        pointerEvents: "auto"
    });
    const [contactTextMediumStyleState, setContactTextMediumStyleState] = useState(getContactTextMediumStyle);
    //CONTACT TEXT DETAIL
    const getContactTextDetailStyle = () => ({
        position: "relative",
        fontSize: getDynamicCssValue(10),
        userSelect: "text",
        pointerEvents: "auto"
    });
    const [contactTextDetailStyleState, setContactTextDetailStyleState] = useState(getContactTextDetailStyle);
    //COPYRIGHT CONTAINER
    const getCopyrightContainerStyle = () => ({
        position: "fixed",
        bottom: getDynamicCssValue(-10),
        left: getDynamicCssValue(122),
        width: getDynamicCssValue(119.31),
        height: getIsMobile() === true ? "auto" : "36px",
        pointerEvents: "none"
    });
    const [copyrightContainerStyleState, setCopyrightContainerStyleState] = useState(getCopyrightContainerStyle);
    //COPYRIGHT TITLE
    const getCopyrightTitleStyle = () => ({
        position: "absolute",
        top: getDynamicCssValue(12, 15),
        left: getDynamicCssValue(20, 21),
        fontSize: getDynamicCssValue(9),
        textAlign: "left",
        userSelect: "text",
        pointerEvents: "auto"
    });
    const [copyrightTitleStyleState, setCopyrightTitleStyleState] = useState(getCopyrightTitleStyle);
    //MENU SVG
    const getMenuSvgStyle = () => ({
  		position: "fixed",
  		top: "0px",
  		left: "0px",
  		width: getDynamicCssValue(360),
  		height: getIsMobile() === true ? "auto" : "360px",
  		filter: "drop-shadow(-1px 2px 1px #00000080)"
    });
    const [menuSvgStyleState, setMenuSvgStyleState] = useState(getMenuSvgStyle);
    //MENU BG SVG
	const getMenuBgSvgStyle = () => ({
  		position: "fixed",
  		top: getDynamicCssValue(-10),
  		left: getDynamicCssValue(-10),
  		width: getDynamicCssValue(420),
  		height: getIsMobile() === true ? "auto" : "420px"
    });
	const [menuBgSvgStyleState, setMenuBgSvgStyleState] = useState(getMenuBgSvgStyle);
    //LOGO SVG
	const getLogoSvgStyle = () => ({
  		position: "fixed",
  		top: getDynamicCssValue(-10),
  		right: getDynamicCssValue(-10),
  		width: getDynamicCssValue(320.25, 276),
  		height: "auto",
  		filter: "drop-shadow(-1px 2px 1px #00000080)"
    });
	const [logoSvgStyleState, setLogoSvgStyleState] = useState(getLogoSvgStyle);
    //PLAY ICON
	const getGooglePlayIconSvgStyle = () => ({
  		position: "fixed",
  		top: getIsPortrait() === true ? "300px" : "100px",
  		right: "8px",
  		width: "38px",
  		height: "auto",
  		filter: "drop-shadow(-1px 2px 1px #00000080)"
    });
	const [googlePlayIconSvgStyleState, setGooglePlayIconSvgStyleState] = useState(getGooglePlayIconSvgStyle);
    //DETAIL CONTROLS LEFT SVG
    const getDetailControlsLeftSvgStyle = () => ({
        position: "fixed",
        bottom: isAndroidAppRef.current === true ? window.visualViewport.height / 2 - getMobileCssValue(24) + "px" : getIsMobile() === true ? "calc(50lvh - " + getMobileCssValue(24) + "px" : "calc(50lvh - 24px)",
        left: "0px",
        width: getDynamicCssValue(48),
        height: getDynamicCssValue(48)
    });
	const [detailControlsLeftSvgStyleState, setDetailControlsLeftSvgStyleState] = useState(getDetailControlsLeftSvgStyle);
    //DETAIL CONTROLS RIGHT SVG
    const getDetailControlsRightSvgStyle = () => ({
        position: "fixed",
        bottom: isAndroidAppRef.current === true ? window.visualViewport.height / 2 - getMobileCssValue(24) + "px" : getIsMobile() === true ? "calc(50lvh - " + getMobileCssValue(24) + "px" : "calc(50lvh - 24px)",
        right: window.visualViewport.height < 560 ? isAndroidAppRef.current === true ? "calc(440px - calc(var(--vh, 1vh) * 29)" : "calc(440px - 29lvh)" : "0px",
        width: getDynamicCssValue(48),
        height: getDynamicCssValue(48)
    });
	const [detailControlsRightSvgStyleState, setDetailControlsRightSvgStyleState] = useState(getDetailControlsRightSvgStyle);
    //DETAIL CONTROLS ITEMS CONTAINER
    const getDetailControlsItemsContainerStyle = () => ({
        position: "fixed",
        display: "flex",
        justifyContent: "center",
        flexDirection: "row",
        gap: "16px",
        bottom: window.innerWidth < 900 ? "264px" : "8px",
        right: window.innerWidth < 900 ? "0px" : window.innerWidth / 2 - 27 + "px",
        width: "232px",
        height: "20px",
        pointerEvents: "none"
    });
	const [detailControlsItemsContainerStyleState, setDetailControlsItemsContainerStyleState] = useState(getDetailControlsItemsContainerStyle);
    //ITEMS CONTROLS LEFT SVG
    const getItemsControlsLeftSvgStyle = () => ({
        position: "absolute",
        paddingTop: getIsMobile() === true ? 144 - getMobileCssValue(24) + "px" : "120px",
        top: "0px",
        left: "0px",
        width: getDynamicCssValue(48),
        height: getDynamicCssValue(48),
        visibility: "hidden"
    });
	const [itemsControlsLeftSvgStyleState, setItemsControlsLeftSvgStyleState] = useState(getItemsControlsLeftSvgStyle);
    //ITEMS CONTROLS RIGHT SVG
    const getItemsControlsRightSvgStyle = () => ({
        position: "absolute",
        paddingTop: getIsMobile() === true ? 144 - getMobileCssValue(24) + "px" : "120px",
        top: "0px",
        right: "0px",
        width: getDynamicCssValue(48),
        height: getDynamicCssValue(48),
        visibility: "hidden"
    });
	const [itemsControlsRightSvgStyleState, setItemsControlsRightSvgStyleState] = useState(getItemsControlsRightSvgStyle);
    //PRIVACY CONTAINER CONTENT
    const getPrivacyContainerContentStyle = () => ({
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: isAndroidAppRef.current === true ? "calc(var(--vw, 1vw) * 100)" : "100vw",
        paddingTop: isAndroidAppRef.current === true ? "calc(var(--vh, 1vh) * 60)" : getIsMobile() === true ? "60lvh" : "30lvh",
        paddingBottom: isAndroidAppRef.current === true ? "calc(var(--vh, 1vh) * 30)" : "30lvh",
        backgroundColor: "#000000cc"
    });
	const [privacyContainerContentStyleState, setPrivacyContainerContentStyleState] = useState(getPrivacyContainerContentStyle);

//STYLE FUNCTIONS
    //GET IS PORTRAIT
    function getIsPortrait() {
        if (window.innerWidth < window.visualViewport.height) {
            return true
        } else {
            return false
        };
    };
    //GET IS MOBILE
    function getIsMobile() {
        if ((isAndroidPhoneRef.current === true || isIOSPhoneRef.current === true) && getIsPortrait()) {
            return true
        } else {
            return false
        };
    };
    //GET MOBILE CSS VALUE
    function getMobileCssValue(value) {
        return (value / 360 * window.innerWidth).toFixed(3)
    };
    //GET DYNAMIC CSS VALUE
    function getDynamicCssValue(dValue, mValue) {
        if (!mValue) {mValue = dValue};

        if (getIsMobile()) {
            return getMobileCssValue(mValue) + "px"
        } else {
            return dValue + "px"
        };
    };
    //GET MAIN CONTAINER VISIBILITY
    function getMainContainerVisibility() {

        const scrollSection = getScrollSection();

        if (scrollSection === "topEnd" || scrollSection === "bottomEnd") {

            return "hidden"

        } else {

            return "visible"

        };

    };
    //GET MEDIA CONTAINER OPACITY
    function getMediaContainerOpacity() {

        const scrollPos = getScrollPosition();
        const scrollSection = getScrollSection();
        const fadeStartBottom = getFadeStartBottom();

        if (scrollSection === "bottomSection") {

            return (0.975 + (scrollPos - fadeStartBottom) * -1 / (1 - fadeStartBottom)).toFixed(3)

        } else if (scrollSection === "bottomEnd") {

            return 0

        } else {

            return 1

        };

    };
    //GET MEDIA CONTAINER VISIBILITY
    function getMediaContainerVisibility() {

        const scrollPos = getScrollPosition();

        if (scrollPos > 0.95) {

            return "hidden"

        } else {

            return "visible"

        };

    };
    //GET WIDGET WIDTH CORRECTION
    function getWidgetWidthCorr() {

        if (window.innerWidth >= 500) {

            return 0

        } else {

            return Math.abs((window.innerWidth - 500) / 2)

        };

    };
    //GET TITLE CONTAINER OPACITY
    function getTitleContainerOpacity() {

        const scrollPos = getScrollPosition();
        const scrollSection = getScrollSection();
        const fadeEndTop = getFadeEndTop();

        if (scrollSection === "topSection" || scrollSection === "topEnd") {

            return (1 + scrollPos * -1 / fadeEndTop).toFixed(3)

        } else {

            return 0

        };

    };
    //GET TITLE CONTAINER VISIBILITY
    function getTitleContainerVisibility() {

        const scrollSection = getScrollSection();

        if (scrollSection === "topSection" || scrollSection === "topEnd") {

            return "visible"

        } else {

            return "hidden"

        };

    };
    //UPDATE CSS
    function updateCss() {
        setMainContainerStyleState(getMainContainerStyle);
        setCheckoutPanelSvgStyleState(getCheckoutPanelSvgStyle);
        setscrollButtonSvgStyleState(getScrollButtonSvgStyle);
        setTitleContainerStyleState(getTitleContainerStyle);
        setTitleTextStyleState(getTitleTextStyle);
        setButtonReadMoreStyleState(getButtonReadMoreStyle);
        setContactContainerStyleState(getContactContainerStyle);
        setContactDetailsStyleState(getContactDetailsStyle);
        setContactTitleStyleState(getContactTitleStyle);
        setContactTextStyleState(getContactTextStyle);
        setContactTextTitleStyleState(getContactTextTitleStyle);
        setContactTextMediumStyleState(getContactTextMediumStyle);
        setContactTextDetailStyleState(getContactTextDetailStyle);
        setCopyrightContainerStyleState(getCopyrightContainerStyle);
        setCopyrightTitleStyleState(getCopyrightTitleStyle);
        setMenuSvgStyleState(getMenuSvgStyle);
        setMenuBgSvgStyleState(getMenuBgSvgStyle);
        setLogoSvgStyleState(getLogoSvgStyle);
        setGooglePlayIconSvgStyleState(getGooglePlayIconSvgStyle);
        setDetailControlsLeftSvgStyleState(getDetailControlsLeftSvgStyle);
        setDetailControlsRightSvgStyleState(getDetailControlsRightSvgStyle);
        setDetailControlsItemsContainerStyleState(getDetailControlsItemsContainerStyle);
        setPrivacyContainerContentStyleState(getPrivacyContainerContentStyle);
        updateDocumentCss();
    };
    //UPDATE DOCUMENT CSS
    function updateDocumentCss() {
        if (document.querySelector('p')) {
            const p = document.querySelectorAll('p');
            if (getIsMobile() === true) {
                p.forEach(p => {
                    p.style.fontSize = '20px';
                });
            } else {
                p.forEach(p => {
                    p.style.fontSize = '';
                });
            };
        };
    };


    // Fetch exchange rate CHF to USD from backend
  	const fetchExRateChfUsd = async () => {
        try {

              const response = await fetch(`${backendUrl}/api/exchange_rate_chf_usd`, {
                    method: 'GET',
                    headers: {
                          'Content-Type': 'application/json',
                    },
              });

              if (!response.ok) {
                    throw new Error(`Network response was not ok, status: ${response.status}`);
              };

              const data = await response.json();
              const exRateChfUsd = data.exRateChfUsd;

              // Validate response is a number
              if (isNaN(exRateChfUsd)) {
                    console.error('Invalid exchange rate:', exRateChfUsd);
              }

              exRateChfUsdRef.current = exRateChfUsd;

        } catch (error) {

              console.error('Failed to fetch shipping estimate:', error.message);

        };
    };

//BODY FUNCTIONS
    function setBodyHeight() {

        let vh = (window.visualViewport.height * 0.01).toFixed(3);
        document.documentElement.style.setProperty('--vh', `${vh}px`);

        let vw = (window.innerWidth * 0.01).toFixed(3);
        document.documentElement.style.setProperty('--vw', `${vw}px`);

        contentHeight.current = pageElementsRefs.mainContainerContent.current.clientHeight;

        pageElementsRefs.bodyElement.current.style.height = contentHeight.current + "px";

        setScrollbarSliderStyleState(getScrollbarSliderStyle());

    };

//SCROLL FUNCTIONS
    //GET SCROLL BAR SLIDER TRANSFORM
    function getScrollbarSliderTransform() {

        return "translateY(" + (window.visualViewport.height * window.scrollY / document.body.scrollHeight).toFixed(3) + "px) translateZ(5px)"

    };
    //GET SCROLLBAR SLIDER HEIGHT
    function getScrollbarSliderHeight() {

        return window.visualViewport.height ** 2 / contentHeight.current + "px"

    };
    //SCROLL TO TITLE
    function scrollToTitle(scrollBehavior) {

        menuLockedRef.current = true;

        let intervalToTitleMenu = setInterval(lockToTitleMenu, 25);
        function lockToTitleMenu() {
            if (getScrollPosition() > 0.05) {
                clearInterval(intervalToTitleMenu);
                menuLockedRef.current = false;
                handleMenu("scroll");
            };
        };

        window.scrollTo({
            top: getFadeEndTopPixel(),
            left: 0,
            behavior: scrollBehavior,
        });
    };
    //SCROLL TO OVERVIEW
    function scrollToOverview(scrollBehavior) {

        menuLockedRef.current = true;

        let intervalToOverviewMenu = setInterval(lockToOverviewMenu, 25);
        function lockToOverviewMenu() {
            if (getScrollPosition() > 0.05) {
                clearInterval(intervalToOverviewMenu);
                menuLockedRef.current = false;
                handleMenu("scroll");
            };
        };

        window.scrollTo({
            top: getFadeStartBottomPixel(),
            left: 0,
            behavior: scrollBehavior,
        });

    };
    //SCROLL TO TOP
    function scrollToTop(scrollBehavior) {

        menuLockedRef.current = true;

        let intervalToTop = setInterval(lockToTop, 25);
        function lockToTop() {
            if (getScrollPosition() < 0.05) {
                clearInterval(intervalToTop);
                menuLockedRef.current = false;
                handleMenu("scroll");
            };
        };

        window.scrollTo({
            top: 0,
            left: 0,
            behavior: scrollBehavior,
        });

    };
    //SCROLL TO BOTTOM
    function scrollToBottom(scrollBehavior) {

        menuLockedRef.current = true;

        let intervalToBottom = setInterval(lockToBottom, 25);
        function lockToBottom() {
            if (getScrollPosition() > 0.05) {
                clearInterval(intervalToBottom);
                menuLockedRef.current = false;
                handleMenu("scroll");
            };
        };

        window.scrollTo({
            top: document.body.scrollHeight,
            left: 0,
            behavior: scrollBehavior,
        });

    };
    //GET SCROLL POSITION
    function getScrollPosition() {

        let scrollPos = (window.scrollY/(document.body.scrollHeight - window.visualViewport.height));

        if (scrollPos < 0.01) {
            scrollPos = 0;
        } else if (scrollPos > 0.99) {
            scrollPos = 1;
        };

        return scrollPos;

    };
    //GET SCROLL SECTION
    function getScrollSection() {

        const scrollPos = getScrollPosition();
        const fadeEndTop = getFadeEndTop();
        const fadeStartBottom = getFadeStartBottom();

        if (scrollPos < 0.05) { //top end

            return "topEnd"

        } else if (scrollPos > 0.95) { //bottom end

            return "bottomEnd"

        } else if (scrollPos <= fadeEndTop) { //top section

            return "topSection"

        } else if (scrollPos >= fadeStartBottom) { //bottom section

            return "bottomSection"

        } else { //main section

            return "mainSection"

        };

    };

//FADE FUNCTIONS
    //GET FADE END TOP
    function getFadeEndTop() {

        return (1 / document.body.scrollHeight * window.visualViewport.height);

    };
    //GET FADE START BOTTOM
    function getFadeStartBottom() {

        return (1 / document.body.scrollHeight * (document.body.scrollHeight - window.visualViewport.height));

    };
    //GET FADE END TOP PIXEL
    function getFadeEndTopPixel() {

        return (getFadeEndTop() * (document.body.scrollHeight - window.visualViewport.height));

    };
    //GET FADE START BOTTOM PIXEL
    function getFadeStartBottomPixel() {

        return (getFadeStartBottom() * (document.body.scrollHeight - window.visualViewport.height));

    };

//MENU FUNCTIONS
    //SET MENU LOCKED
    function setMenuLocked(value) {
        menuLockedRef.current = value;
    };
    //HANDLE MENU
    function handleMenu(type) {

        if (menuRunningRef.current === false && menuLockedRef.current === false) {

            menuRunningRef.current = true;

            const intervalSpeed = 0.35;
            const intervalDelay = 5;

            let scrollPos = getScrollPosition();

            function expandMenu() {

                setWidgetState(false);
                setDetailWidgetState(false);

                let menuBgOpacity = 0;
                let intervalMenuBgTimePrevious = Date.now();
                let intervalMenuBgOpacity = setInterval(opacityBgMenu, intervalDelay);
                function opacityBgMenu() {
                    let intervalDeltaTime = Date.now() - intervalMenuBgTimePrevious;
                    if (menuBgOpacity < 0.75) {
                        menuBgOpacity = Math.min(menuBgOpacity + intervalDeltaTime * 0.002, 0.75);
                        menuElementsRefs.menuBg.current.setAttribute("opacity", menuBgOpacity);
                        intervalMenuBgTimePrevious = Date.now();
                    } else {
                        clearInterval(intervalMenuBgOpacity);
                    };
                };

                menuElementsRefs.buttonMenu.current.setAttribute("display", "none");

                function setHomeVisible() {
                    setTimeout(function() {
                        menuElementsRefs.textHomeH.current.setAttribute("visibility", "visible");
                    }, 30);
                    setTimeout(function() {
                        menuElementsRefs.textHomeO.current.setAttribute("visibility", "visible");
                    }, 60);
                    setTimeout(function() {
                        menuElementsRefs.textHomeM.current.setAttribute("visibility", "visible");
                    }, 90);
                    setTimeout(function() {
                        menuElementsRefs.textHomeE.current.setAttribute("visibility", "visible");
                        menuElementsRefs.linkHome.current.setAttribute("visibility", "visible");
                    }, 120);
                };

                let pathHomeOffset = 169;
                let intervalHomeTimePrevious = Date.now();
                let intervalHome = setInterval(offsetHome, intervalDelay);
                function offsetHome() {
                    let intervalDeltaTime = Date.now() - intervalHomeTimePrevious;
                    if (pathHomeOffset > 0) {
                        pathHomeOffset = Math.max(pathHomeOffset - intervalDeltaTime * intervalSpeed, 0);
                        menuElementsRefs.pathHome.current.setAttribute("stroke-dashoffset", pathHomeOffset);
                        intervalHomeTimePrevious = Date.now();
                    } else {
                        clearInterval(intervalHome);
                        setHomeVisible();

                        let circleHomeOffset = 13;
                        let intervalHomeCircleTimePrevious = Date.now();
                        let intervalHomeCircle = setInterval(offsetHomeCircle, intervalDelay);
                        function offsetHomeCircle() {
                            let intervalDeltaTime = Date.now() - intervalHomeCircleTimePrevious;
                            if (circleHomeOffset > 0) {
                                circleHomeOffset = Math.max(circleHomeOffset - intervalDeltaTime * intervalSpeed, 0);
                                menuElementsRefs.circleHome0.current.setAttribute("stroke-dashoffset", circleHomeOffset);
                                menuElementsRefs.circleHome1.current.setAttribute("stroke-dashoffset", circleHomeOffset);
                                intervalHomeCircleTimePrevious = Date.now();
                            } else {
                                clearInterval(intervalHomeCircle);
                                menuElementsRefs.dotHome.current.setAttribute("opacity", 1);
                            };
                        };
                    };
                };

                function setDigitalVisible() {
                    setTimeout(function() {
                        menuElementsRefs.textDigitalD.current.setAttribute("visibility", "visible");
                    }, 30);
                    setTimeout(function() {
                        menuElementsRefs.textDigitalI0.current.setAttribute("visibility", "visible");
                    }, 60);
                    setTimeout(function() {
                        menuElementsRefs.textDigitalG.current.setAttribute("visibility", "visible");
                    }, 90);
                    setTimeout(function() {
                        menuElementsRefs.textDigitalI1.current.setAttribute("visibility", "visible");
                    }, 120);
                    setTimeout(function() {
                        menuElementsRefs.textDigitalT.current.setAttribute("visibility", "visible");
                    }, 150);
                    setTimeout(function() {
                        menuElementsRefs.textDigitalA.current.setAttribute("visibility", "visible");
                    }, 180);
                    setTimeout(function() {
                        menuElementsRefs.textDigitalL.current.setAttribute("visibility", "visible");
                        menuElementsRefs.linkDigital.current.setAttribute("visibility", "visible");
                    }, 210);
                };

                let pathDigitalOffset = 152;
                let intervalDigitalTimePrevious = Date.now();
                let intervalDigital = setInterval(offsetDigital, intervalDelay);
                function offsetDigital() {
                    let intervalDeltaTime = Date.now() - intervalDigitalTimePrevious;
                    if (pathDigitalOffset > 0) {
                        pathDigitalOffset = Math.max(pathDigitalOffset - intervalDeltaTime * intervalSpeed, 0);
                        menuElementsRefs.pathDigital.current.setAttribute("stroke-dashoffset", pathDigitalOffset);
                        intervalDigitalTimePrevious = Date.now();
                    } else {
                        clearInterval(intervalDigital);
                        setDigitalVisible();

                        let circleDigitalOffset = 13;
                        let intervalDigitalCircleTimePrevious = Date.now();
                        let intervalDigitalCircle = setInterval(offsetDigitalCircle, intervalDelay);
                        function offsetDigitalCircle() {
                            let intervalDeltaTime = Date.now() - intervalDigitalCircleTimePrevious;
                            if (circleDigitalOffset > 0) {
                                circleDigitalOffset = Math.max(circleDigitalOffset - intervalDeltaTime * intervalSpeed, 0);
                                menuElementsRefs.circleDigital0.current.setAttribute("stroke-dashoffset", circleDigitalOffset);
                                menuElementsRefs.circleDigital1.current.setAttribute("stroke-dashoffset", circleDigitalOffset);
                                intervalDigitalCircleTimePrevious = Date.now();
                            } else {
                                clearInterval(intervalDigitalCircle);
                                menuElementsRefs.dotDigital.current.setAttribute("opacity", 1);
                            };
                        };
                    };
                };

                function setGamesVisible() {
                    setTimeout(function() {
                        menuElementsRefs.textGamesG.current.setAttribute("visibility", "visible");
                    }, 30);
                    setTimeout(function() {
                        menuElementsRefs.textGamesA.current.setAttribute("visibility", "visible");
                    }, 60);
                    setTimeout(function() {
                        menuElementsRefs.textGamesM.current.setAttribute("visibility", "visible");
                    }, 90);
                    setTimeout(function() {
                        menuElementsRefs.textGamesE.current.setAttribute("visibility", "visible");
                    }, 120);
                    setTimeout(function() {
                        menuElementsRefs.textGamesS.current.setAttribute("visibility", "visible");
                        menuElementsRefs.linkGames.current.setAttribute("visibility", "visible");
                    }, 150);
                };

                let pathGamesOffset = 162;
                let intervalGamesTimePrevious = Date.now();
                let intervalGames = setInterval(offsetGames, intervalDelay);
                function offsetGames() {
                    let intervalDeltaTime = Date.now() - intervalGamesTimePrevious;
                    if (pathGamesOffset > 0) {
                        pathGamesOffset = Math.max(pathGamesOffset - intervalDeltaTime * intervalSpeed, 0);
                        menuElementsRefs.pathGames.current.setAttribute("stroke-dashoffset", pathGamesOffset);
                        intervalGamesTimePrevious = Date.now();
                    } else {
                        clearInterval(intervalGames);
                        setGamesVisible();

                        let circleGamesOffset = 13;
                        let intervalGamesCircleTimePrevious = Date.now();
                        let intervalGamesCircle = setInterval(offsetGamesCircle, intervalDelay);
                        function offsetGamesCircle() {
                            let intervalDeltaTime = Date.now() - intervalGamesCircleTimePrevious;
                            if (circleGamesOffset > 0) {
                                circleGamesOffset = Math.max(circleGamesOffset - intervalDeltaTime * intervalSpeed, 0);
                                menuElementsRefs.circleGames0.current.setAttribute("stroke-dashoffset", circleGamesOffset);
                                menuElementsRefs.circleGames1.current.setAttribute("stroke-dashoffset", circleGamesOffset);
                                intervalGamesCircleTimePrevious = Date.now();
                            } else {
                                clearInterval(intervalGamesCircle);
                                menuElementsRefs.dotGames.current.setAttribute("opacity", 1);
                            };
                        };
                    };
                };

                function setDesignVisible() {
                    setTimeout(function() {
                        menuElementsRefs.textDesignD.current.setAttribute("visibility", "visible");
                    }, 30);
                    setTimeout(function() {
                        menuElementsRefs.textDesignE.current.setAttribute("visibility", "visible");
                    }, 60);
                    setTimeout(function() {
                        menuElementsRefs.textDesignS.current.setAttribute("visibility", "visible");
                    }, 90);
                    setTimeout(function() {
                        menuElementsRefs.textDesignI.current.setAttribute("visibility", "visible");
                    }, 120);
                    setTimeout(function() {
                        menuElementsRefs.textDesignG.current.setAttribute("visibility", "visible");
                    }, 150);
                    setTimeout(function() {
                        menuElementsRefs.textDesignN.current.setAttribute("visibility", "visible");
                        menuElementsRefs.linkDesign.current.setAttribute("visibility", "visible");
                    }, 180);
                };

                let pathDesignOffset = 210;
                let intervalDesignTimePrevious = Date.now();
                let intervalDesign = setInterval(offsetDesign, intervalDelay);
                function offsetDesign() {
                    let intervalDeltaTime = Date.now() - intervalDesignTimePrevious;
                    if (pathDesignOffset > 0) {
                        pathDesignOffset = Math.max(pathDesignOffset - intervalDeltaTime * intervalSpeed, 0);
                        menuElementsRefs.pathDesign.current.setAttribute("stroke-dashoffset", pathDesignOffset);
                        intervalDesignTimePrevious = Date.now();
                    } else {
                        clearInterval(intervalDesign);
                        setDesignVisible();

                        let circleDesignOffset = 13;
                        let intervalDesignCircleTimePrevious = Date.now();
                        let intervalDesignCircle = setInterval(offsetDesignCircle, intervalDelay);
                        function offsetDesignCircle() {
                            let intervalDeltaTime = Date.now() - intervalDesignCircleTimePrevious;
                            if (circleDesignOffset > 0) {
                                circleDesignOffset = Math.max(circleDesignOffset - intervalDeltaTime * intervalSpeed, 0);
                                menuElementsRefs.circleDesign0.current.setAttribute("stroke-dashoffset", circleDesignOffset);
                                menuElementsRefs.circleDesign1.current.setAttribute("stroke-dashoffset", circleDesignOffset);
                                intervalDesignCircleTimePrevious = Date.now();
                            } else {
                                clearInterval(intervalDesignCircle);
                                menuElementsRefs.dotDesign.current.setAttribute("opacity", 1);
                            };
                        };
                    };
                };

                function setStoreVisible() {
                    setTimeout(function() {
                        menuElementsRefs.textStoreS.current.setAttribute("visibility", "visible");
                    }, 30);
                    setTimeout(function() {
                        menuElementsRefs.textStoreT.current.setAttribute("visibility", "visible");
                    }, 60);
                    setTimeout(function() {
                        menuElementsRefs.textStoreO.current.setAttribute("visibility", "visible");
                    }, 90);
                    setTimeout(function() {
                        menuElementsRefs.textStoreR.current.setAttribute("visibility", "visible");
                    }, 120);
                    setTimeout(function() {
                        menuElementsRefs.textStoreE.current.setAttribute("visibility", "visible");
                        menuElementsRefs.linkStore.current.setAttribute("visibility", "visible");
                    }, 150);
                };

                let pathStoreOffset = 257;
                let intervalStoreTimePrevious = Date.now();
                let intervalStore = setInterval(offsetStore, intervalDelay);
                function offsetStore() {
                    let intervalDeltaTime = Date.now() - intervalStoreTimePrevious;
                    if (pathStoreOffset > 0) {
                        pathStoreOffset = Math.max(pathStoreOffset - intervalDeltaTime * intervalSpeed, 0);
                        menuElementsRefs.pathStore.current.setAttribute("stroke-dashoffset", pathStoreOffset);
                        intervalStoreTimePrevious = Date.now();
                    } else {
                        clearInterval(intervalStore);
                        setStoreVisible();

                        let circleStoreOffset = 13;
                        let intervalStoreCircleTimePrevious = Date.now();
                        let intervalStoreCircle = setInterval(offsetStoreCircle, intervalDelay);
                        function offsetStoreCircle() {
                            let intervalDeltaTime = Date.now() - intervalStoreCircleTimePrevious;
                            if (circleStoreOffset > 0) {
                                circleStoreOffset = Math.max(circleStoreOffset - intervalDeltaTime * intervalSpeed, 0);
                                menuElementsRefs.circleStore0.current.setAttribute("stroke-dashoffset", circleStoreOffset);
                                menuElementsRefs.circleStore1.current.setAttribute("stroke-dashoffset", circleStoreOffset);
                                intervalStoreCircleTimePrevious = Date.now();
                            } else {
                                clearInterval(intervalStoreCircle);
                                menuElementsRefs.dotStore.current.setAttribute("opacity", 1);
                            };
                        };
                    };
                };

                setTimeout(function() {
                    menuExpandedRef.current = true;
                    menuRunningRef.current = false;
                    menuElementsRefs.buttonMenu.current.setAttribute("display", "true");
                    menuElementsRefs.menuBg.current.setAttribute("pointer-events", "auto");
                }, 1000);

            };

            function collapseMenu() {

                let menuBgOpacity = 0.75;
                let intervalMenuBgTimePrevious = Date.now();
                let intervalMenuBgOpacity = setInterval(opacityBgMenu, intervalDelay);
                function opacityBgMenu() {
                    let intervalDeltaTime = Date.now() - intervalMenuBgTimePrevious;
                    if (menuBgOpacity > 0) {
                        menuBgOpacity = Math.max(menuBgOpacity - intervalDeltaTime * 0.002, 0);
                        menuElementsRefs.menuBg.current.setAttribute("opacity", menuBgOpacity);
                        intervalMenuBgTimePrevious = Date.now();
                    } else {
                        clearInterval(intervalMenuBgOpacity);
                    };
                };

                menuElementsRefs.buttonMenu.current.setAttribute("display", "none");

                menuElementsRefs.linkHome.current.setAttribute("visibility", "hidden");
                menuElementsRefs.linkDigital.current.setAttribute("visibility", "hidden");
                menuElementsRefs.linkGames.current.setAttribute("visibility", "hidden");
                menuElementsRefs.linkDesign.current.setAttribute("visibility", "hidden");
                menuElementsRefs.linkStore.current.setAttribute("visibility", "hidden");

                menuElementsRefs.textHomeE.current.setAttribute("visibility", "hidden");
                menuElementsRefs.textDigitalL.current.setAttribute("visibility", "hidden");
                menuElementsRefs.textGamesS.current.setAttribute("visibility", "hidden");
                menuElementsRefs.textDesignN.current.setAttribute("visibility", "hidden");
                menuElementsRefs.textStoreE.current.setAttribute("visibility", "hidden");

                setTimeout(function() {
                    menuElementsRefs.textHomeM.current.setAttribute("visibility", "hidden");
                    menuElementsRefs.textDigitalA.current.setAttribute("visibility", "hidden");
                    menuElementsRefs.textGamesE.current.setAttribute("visibility", "hidden");
                    menuElementsRefs.textDesignG.current.setAttribute("visibility", "hidden");
                    menuElementsRefs.textStoreR.current.setAttribute("visibility", "hidden");
                }, 30);

                setTimeout(function() {
                    menuElementsRefs.textHomeO.current.setAttribute("visibility", "hidden");
                    menuElementsRefs.textDigitalT.current.setAttribute("visibility", "hidden");
                    menuElementsRefs.textGamesM.current.setAttribute("visibility", "hidden");
                    menuElementsRefs.textDesignI.current.setAttribute("visibility", "hidden");
                    menuElementsRefs.textStoreO.current.setAttribute("visibility", "hidden");
                }, 60);

                setTimeout(function() {
                    menuElementsRefs.textHomeH.current.setAttribute("visibility", "hidden");
                    menuElementsRefs.textDigitalI1.current.setAttribute("visibility", "hidden");
                    menuElementsRefs.textGamesA.current.setAttribute("visibility", "hidden");
                    menuElementsRefs.textDesignS.current.setAttribute("visibility", "hidden");
                    menuElementsRefs.textStoreT.current.setAttribute("visibility", "hidden");

                    let circleHomeOffset = 0;
                    let intervalHomeCircleTimePrevious = Date.now();
                    let intervalCircleHome = setInterval(offsetCircleHome, intervalDelay);
                    function offsetCircleHome() {
                        let intervalDeltaTime = Date.now() - intervalHomeCircleTimePrevious;
                        if (circleHomeOffset < 13) {
                            circleHomeOffset = Math.min(circleHomeOffset + intervalDeltaTime * intervalSpeed, 13);
                            menuElementsRefs.circleHome0.current.setAttribute("stroke-dashoffset", circleHomeOffset);
                            menuElementsRefs.circleHome1.current.setAttribute("stroke-dashoffset", circleHomeOffset);
                            intervalHomeCircleTimePrevious = Date.now();
                        } else {
                            clearInterval(intervalCircleHome);
                            menuElementsRefs.dotHome.current.setAttribute("opacity", 0);

                            let pathHomeOffset = 0;
                            let intervalHomeTimePrevious = Date.now();
                            let intervalHome = setInterval(offsetHome, intervalDelay);
                            function offsetHome() {
                                let intervalDeltaTime = Date.now() - intervalHomeTimePrevious;
                                if (pathHomeOffset < 169) {
                                    pathHomeOffset = Math.min(pathHomeOffset + intervalDeltaTime * intervalSpeed, 169);
                                    menuElementsRefs.pathHome.current.setAttribute("stroke-dashoffset", pathHomeOffset);
                                    intervalHomeTimePrevious = Date.now();
                                } else {
                                    clearInterval(intervalHome);
                                };
                            };
                        };
                    };

                }, 90);

                setTimeout(function() {
                    menuElementsRefs.textDigitalG.current.setAttribute("visibility", "hidden");
                    menuElementsRefs.textGamesG.current.setAttribute("visibility", "hidden");
                    menuElementsRefs.textDesignE.current.setAttribute("visibility", "hidden");
                    menuElementsRefs.textStoreS.current.setAttribute("visibility", "hidden");

                    let circleGamesOffset = 0;
                    let intervalGamesCircleTimePrevious = Date.now();
                    let intervalGamesCircle = setInterval(offsetGamesCircle, intervalDelay);
                    function offsetGamesCircle() {
                        let intervalDeltaTime = Date.now() - intervalGamesCircleTimePrevious;
                        if (circleGamesOffset < 13) {
                            circleGamesOffset = Math.min(circleGamesOffset + intervalDeltaTime * intervalSpeed, 13);
                            menuElementsRefs.circleGames0.current.setAttribute("stroke-dashoffset", circleGamesOffset);
                            menuElementsRefs.circleGames1.current.setAttribute("stroke-dashoffset", circleGamesOffset);
                            intervalGamesCircleTimePrevious = Date.now();
                        } else {
                            clearInterval(intervalGamesCircle);
                            menuElementsRefs.dotGames.current.setAttribute("opacity", 0);

                            let pathGamesOffset = 0;
                            let intervalGamesTimePrevious = Date.now();
                            let intervalGames = setInterval(offsetGames, intervalDelay);
                            function offsetGames() {
                                let intervalDeltaTime = Date.now() - intervalGamesTimePrevious;
                                if (pathGamesOffset < 162) {
                                    pathGamesOffset = Math.min(pathGamesOffset + intervalDeltaTime * intervalSpeed, 162);
                                    menuElementsRefs.pathGames.current.setAttribute("stroke-dashoffset", pathGamesOffset);
                                    intervalGamesTimePrevious = Date.now();
                                } else {
                                    clearInterval(intervalGames);
                                };
                            };
                        };
                    };

                    let circleStoreOffset = 0;
                    let intervalStoreCircleTimePrevious = Date.now();
                    let intervalStoreCircle = setInterval(offsetStoreCircle, intervalDelay);
                    function offsetStoreCircle() {
                        let intervalDeltaTime = Date.now() - intervalStoreCircleTimePrevious;
                        if (circleStoreOffset < 13) {
                            circleStoreOffset = Math.min(circleStoreOffset + intervalDeltaTime * intervalSpeed, 13);
                            menuElementsRefs.circleStore0.current.setAttribute("stroke-dashoffset", circleStoreOffset);
                            menuElementsRefs.circleStore1.current.setAttribute("stroke-dashoffset", circleStoreOffset);
                            intervalStoreCircleTimePrevious = Date.now();
                        } else {
                            clearInterval(intervalStoreCircle);
                            menuElementsRefs.dotStore.current.setAttribute("opacity", 0);

                            let pathStoreOffset = 0;
                            let intervalStoreTimePrevious = Date.now();
                            let intervalStore = setInterval(offsetStore, intervalDelay);
                            function offsetStore() {
                                let intervalDeltaTime = Date.now() - intervalStoreTimePrevious;
                                if (pathStoreOffset < 257) {
                                    pathStoreOffset = Math.min(pathStoreOffset + intervalDeltaTime * intervalSpeed, 257);
                                    menuElementsRefs.pathStore.current.setAttribute("stroke-dashoffset", pathStoreOffset);
                                    intervalStoreTimePrevious = Date.now();
                                } else {
                                    clearInterval(intervalStore);
                                };
                            };
                        };
                    };

                }, 120);

                setTimeout(function() {
                    menuElementsRefs.textDigitalI0.current.setAttribute("visibility", "hidden");
                    menuElementsRefs.textDesignD.current.setAttribute("visibility", "hidden");

                    let circleDesignOffset = 0;
                    let intervalDesignCircleTimePrevious = Date.now();
                    let intervalDesignCircle = setInterval(offsetDesignCircle, intervalDelay);
                    function offsetDesignCircle() {
                        let intervalDeltaTime = Date.now() - intervalDesignCircleTimePrevious;
                        if (circleDesignOffset < 13) {
                            circleDesignOffset = Math.min(circleDesignOffset + intervalDeltaTime * intervalSpeed, 13);
                            menuElementsRefs.circleDesign0.current.setAttribute("stroke-dashoffset", circleDesignOffset);
                            menuElementsRefs.circleDesign1.current.setAttribute("stroke-dashoffset", circleDesignOffset);
                            intervalDesignCircleTimePrevious = Date.now();
                        } else {
                            clearInterval(intervalDesignCircle);
                            menuElementsRefs.dotDesign.current.setAttribute("opacity", 0);

                            let pathDesignOffset = 0;
                            let intervalDesignTimePrevious = Date.now();
                            let intervalDesign = setInterval(offsetDesign, intervalDelay);
                            function offsetDesign() {
                                let intervalDeltaTime = Date.now() - intervalDesignTimePrevious;
                                if (pathDesignOffset < 210) {
                                    pathDesignOffset = Math.min(pathDesignOffset + intervalDeltaTime * intervalSpeed, 210);
                                    menuElementsRefs.pathDesign.current.setAttribute("stroke-dashoffset", pathDesignOffset);
                                    intervalDesignTimePrevious = Date.now();
                                } else {
                                    clearInterval(intervalDesign);
                                };
                            };
                        };
                    };

                }, 150);

                setTimeout(function() {
                    menuElementsRefs.textDigitalD.current.setAttribute("visibility", "hidden");

                    let circleDigitalOffset = 0;
                    let intervalDigitalCircleTimePrevious = Date.now();
                    let intervalDigitalCircle = setInterval(offsetDigitalCircle, intervalDelay);
                    function offsetDigitalCircle() {
                        let intervalDeltaTime = Date.now() - intervalDigitalCircleTimePrevious;
                        if (circleDigitalOffset < 13) {
                            circleDigitalOffset = Math.min(circleDigitalOffset + intervalDeltaTime * intervalSpeed, 13);
                            menuElementsRefs.circleDigital0.current.setAttribute("stroke-dashoffset", circleDigitalOffset);
                            menuElementsRefs.circleDigital1.current.setAttribute("stroke-dashoffset", circleDigitalOffset);
                            intervalDigitalCircleTimePrevious = Date.now();
                        } else {
                            clearInterval(intervalDigitalCircle);
                            menuElementsRefs.dotDigital.current.setAttribute("opacity", 0);

                            let pathDigitalOffset = 0;
                            let intervalDigitalTimePrevious = Date.now();
                            let intervalDigital = setInterval(offsetDigital, intervalDelay);
                            function offsetDigital() {
                                let intervalDeltaTime = Date.now() - intervalDigitalTimePrevious;
                                if (pathDigitalOffset < 152) {
                                    pathDigitalOffset = Math.min(pathDigitalOffset + intervalDeltaTime * intervalSpeed, 152);
                                    menuElementsRefs.pathDigital.current.setAttribute("stroke-dashoffset", pathDigitalOffset);
                                    intervalDigitalTimePrevious = Date.now();
                                } else {
                                    clearInterval(intervalDigital);
                                };
                            };
                        };
                    };

                }, 180);

                setTimeout(function() {
                    menuExpandedRef.current = false;
                    menuRunningRef.current = false;
                    menuElementsRefs.buttonMenu.current.setAttribute("display", "true");
                    menuElementsRefs.menuBg.current.setAttribute("pointer-events", "none");
                }, 1000);

            };

            if (type === "click") {

                if (!menuExpandedRef.current) {

                    expandMenu();

                } else if (menuExpandedRef.current) {

                    collapseMenu();

                };

            } else if ((type === "scroll" || type === "scrollend") && !menuExpandedRef.current && scrollPos < 0.05 && scrollPos < scrollPrevPosRef.current) {

                expandMenu();

            } else if (type === "scroll" && menuExpandedRef.current && scrollPos > 0.05) {

                collapseMenu();

            } else if (type === "expand" && !menuExpandedRef.current && scrollPos < 0.05) {

                expandMenu();

            } else if (type === "collapse" && menuExpandedRef.current) {

                collapseMenu();

            } else {

                menuRunningRef.current = false;

            };

            scrollPrevPosRef.current = scrollPos;

        };

    };

//CHECKOUT PANEL FUNCTIONS
    //HANDLE CHECKOUT PANEL
    function handleCheckoutPanel(state, reset) {
        if(state === true) {
            setCheckoutPanelState(true);
            handleMenu("collapse");
            handleContactContainer("collapse");
            setDetailWidgetState(false);
            setWidgetState(false);
            setScrollbarState(false);
            setScrollButtonState(false);
            pageElementsRefs.bodyElement.current.style.overflowY = "hidden";
        } else {

            if (checkoutPanelContentState === "success" || reset === true) {
                resetCheckoutPanel();
            };

            setCheckoutPanelState(false);
            pageElementsRefs.bodyElement.current.style.overflowY = "scroll";
            setScrollbarState(true);
            setScrollButtonState(true);

        };
    };
    //RESET CHECKOUT PANEL
    function resetCheckoutPanel() {

        localStorage.removeItem("cartContent");

        setCartContent([]);
        setCheckoutPanelButtonState(false);
        setCheckoutPanelContentState("cart");
        setCheckoutPanelCountryState("select_country");
        setPaypalSuccessState(false);
        setShippingCostState(0);

    };

//CONTACT CONTAINER FUNCTIONS
    //GET CONTACT CONTAINER OFFSET COLLAPSED
    function getContactContainerOffsetCollapsed() {

        return Number(getDynamicCssValue(-266, -269).slice(0, -2))

    };
    //GET CONTACT CONTAINER OFFSET EXPANDED
    function getContactContainerOffsetExpanded() {

        return Number(getDynamicCssValue(-10, -13).slice(0, -2))

    };
    //EXPAND CONTACT CONTAINER
    function expandContactContainer() {

        setDetailWidgetState(false);
        setWidgetState(false);

        contactContainerRunningRef.current = true;

        const intervalSpeed = 1;
        const intervalDelay = 5;

        let contactContainerOffset = getContactContainerOffsetCollapsed();
        let contactContainerTarget = getContactContainerOffsetExpanded();
        let intervalContactContainerTimePrevious = Date.now();

        let intervalContactContainer = setInterval(expandContactContainerInt, intervalDelay);
        function expandContactContainerInt() {
            let intervalDeltaTime = Date.now() - intervalContactContainerTimePrevious;
            if (contactContainerOffset !== contactContainerTarget) {
                contactContainerOffset = Math.min(contactContainerOffset + intervalDeltaTime * intervalSpeed, contactContainerTarget);
                setContactContainerStyleState(prevState => ({
                    ...prevState,
                    bottom: contactContainerOffset + "px",
                }));
                intervalContactContainerTimePrevious = Date.now();
            } else {
                clearInterval(intervalContactContainer);

                setContactButtonArrowState(true);

                contactContainerStatusRef.current = true;
                contactContainerRunningRef.current = false;;
            };

        };

    };
    //COLLAPSE CONTACT CONTAINER
    function collapseContactContainer() {

        if (contactContainerStatusRef.current === true && contactContainerRunningRef.current === false) {

            contactContainerRunningRef.current = true;

            const intervalSpeed = 1;
            const intervalDelay = 5;

            let contactContainerOffset = getContactContainerOffsetExpanded();
            let contactContainerTarget = getContactContainerOffsetCollapsed();
            let intervalContactContainerTimePrevious = Date.now();

            let intervalContactContainer = setInterval(collapseContactContainerInt, intervalDelay);
            function collapseContactContainerInt() {
                let intervalDeltaTime = Date.now() - intervalContactContainerTimePrevious;
                if (contactContainerOffset !== contactContainerTarget) {
                    contactContainerOffset = Math.max(contactContainerOffset - intervalDeltaTime * intervalSpeed, contactContainerTarget);
                    setContactContainerStyleState(prevState => ({
                        ...prevState,
                        bottom: contactContainerOffset + "px",
                    }));
                    intervalContactContainerTimePrevious = Date.now();
                } else {
                    clearInterval(intervalContactContainer);

                    setContactButtonArrowState(false);

                    contactContainerStatusRef.current = false;
                    contactContainerRunningRef.current = false;;
                };

            };

        };

    };
    //HANDLE CONTACT CONTAINER
    function handleContactContainer(type) {

        if (contactContainerRunningRef.current === false) {

            if (contactContainerStatusRef.current === false && type !== "collapse") {
                expandContactContainer();
            } else {
                collapseContactContainer();
            };

        };

    };

//USE EFFECT INITIAL RENDER
  	useEffect(() => {

        updateCss();
        fetchExRateChfUsd();
                                                                // eslint-disable-next-line
    }, []);

    const router = createBrowserRouter([
        {
            path: "/404",
            element: (<><Error /><Checkout /><Widget /><Header /><Footer /></>),
        },
        {
            path: "/500",
            element: (<><Error /><Checkout /><Widget /><Header /><Footer /></>),
        },
        {
            path: "/privacy",
            element: (<><Privacy /><Scrollbar /><Checkout /><Widget /><Header /><Footer /></>),
        },
        {
            path: "/",
            element: (<><Page /><Scrollbar /><Checkout /><Widget /><Header /><Footer /></>),
            children:
            [
                {
                    path: ":page",
                    element: (
                        <Page />
                    ),
                    children:
                    [
                        {
                            path: ":section",
                            element: (
                                <Page />
                            ),
                            children:
                            [
                                {
                                    path: ":item",
                                    element: (
                                        <Page />
                                    ),
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ]);

    return (
        <AppContext.Provider
            value={{
            //GENERAL
                pageElementsRefs: pageElementsRefs,
                setBodyHeight: setBodyHeight,
                backendUrl: backendUrl,
	        //DEVICE OS DETECTION
		        isAndroidPhoneRef: isAndroidPhoneRef,
	        //APP DETECTION
		        isAndroidAppRef: isAndroidAppRef,
            //MENU
                handleMenu: handleMenu,
                menuElementsRefs: menuElementsRefs,
                setMenuLocked: setMenuLocked,
            //CONTACT CONTAINER
                handleContactContainer: handleContactContainer,
                contactButtonArrowState: contactButtonArrowState,
            //WIDGET
                widgetState: widgetState,
                setWidgetState: setWidgetState,
                getWidgetWidthCorr: getWidgetWidthCorr,
            //CHECKOUT PANEL
                exRateChfUsdRef: exRateChfUsdRef,
                cartItemLimitRef: cartItemLimitRef,
                cartContent: cartContent,
                setCartContent: setCartContent,
                checkoutPanelState: checkoutPanelState,
                checkoutPanelContentState: checkoutPanelContentState,
                setCheckoutPanelContentState: setCheckoutPanelContentState,
                checkoutPanelCountryState: checkoutPanelCountryState,
                setCheckoutPanelCountryState: setCheckoutPanelCountryState,
                checkoutPanelButtonState: checkoutPanelButtonState,
                setCheckoutPanelButtonState: setCheckoutPanelButtonState,
                paypalSuccessState: paypalSuccessState,
                setPaypalSuccessState: setPaypalSuccessState,
                shippingCostState: shippingCostState,
                setShippingCostState: setShippingCostState,
                handleCheckoutPanel: handleCheckoutPanel,
                cartDutyState: cartDutyState,
                setCartDutyState: setCartDutyState,
            //SCROLL
                scrollButtonState: scrollButtonState,
                setScrollButtonState: setScrollButtonState,
                scrollbarState: scrollbarState,
                scrollToTitle: scrollToTitle,
                scrollToOverview: scrollToOverview,
                scrollToTop: scrollToTop,
                scrollToBottom: scrollToBottom,
                getScrollPosition: getScrollPosition,
                getScrollSection: getScrollSection,
            //DETAIL
                detailMediaLoadedRef: detailMediaLoadedRef,
                detailMediaLoaderState: detailMediaLoaderState,
                detailItemActiveRef: detailItemActiveRef,
                setDetailMediaLoaderState: setDetailMediaLoaderState,
                detailWidgetState: detailWidgetState,
                setDetailWidgetState: setDetailWidgetState,
            //FADE FUNCTIONS
                getFadeEndTop: getFadeEndTop,
                getFadeStartBottom: getFadeStartBottom,
                getFadeEndTopPixel: getFadeEndTopPixel,
                getFadeStartBottomPixel: getFadeStartBottomPixel,
            //STYLE
                updateCss: updateCss,
                widgetStyleState: widgetStyleState,
                widgetContainerStyleState: widgetContainerStyleState,
                mainContainerStyleState: mainContainerStyleState,
                setMainContainerStyleState: setMainContainerStyleState,
                getMainContainerVisibility: getMainContainerVisibility,
                mainContainerContentStyleState: mainContainerContentStyleState,
                mediaStyleState: mediaStyleState,
                mediaLoaderContainerStyleState: mediaLoaderContainerStyleState,
                setMediaLoaderContainerStyleState: setMediaLoaderContainerStyleState,
                scrollbarStyleState: scrollbarStyleState,
                scrollbarSliderStyleState: scrollbarSliderStyleState,
                setScrollbarSliderStyleState: setScrollbarSliderStyleState,
                getScrollbarSliderStyle: getScrollbarSliderStyle,
                checkoutPanelStyleState: checkoutPanelStyleState,
                checkoutPanelCountryOverlayStyleState: checkoutPanelCountryOverlayStyleState,
                detailContainerStyleState: detailContainerStyleState,
                detailPlayButtonSvgStyleState: detailPlayButtonSvgStyleState,
                detailWidgetStyleState: detailWidgetStyleState,
                itemsContainerContentStyleState: itemsContainerContentStyleState,
                detailMediaTopStyleState: detailMediaTopStyleState,
                setDetailMediaTopStyleState: setDetailMediaTopStyleState,
                detailMediaBottomStyleState: detailMediaBottomStyleState,
                setDetailMediaBottomStyleState: setDetailMediaBottomStyleState,
                checkoutPanelSvgStyleState: checkoutPanelSvgStyleState,
                scrollButtonSvgStyleState: scrollButtonSvgStyleState,
                mediaContainerOpacityState: mediaContainerOpacityState,
                setMediaContainerOpacityState: setMediaContainerOpacityState,
                getMediaContainerOpacity: getMediaContainerOpacity,
                mediaContainerVisibilityState: mediaContainerVisibilityState,
                setMediaContainerVisibilityState: setMediaContainerVisibilityState,
                getMediaContainerVisibility: getMediaContainerVisibility,
                getTitleContainerOpacity: getTitleContainerOpacity,
                getTitleContainerVisibility: getTitleContainerVisibility,
                titleContainerStyleState: titleContainerStyleState,
                setTitleContainerStyleState: setTitleContainerStyleState,
                titleTextStyleState: titleTextStyleState,
                buttonReadMoreStyleState: buttonReadMoreStyleState,
                contactContainerStyleState: contactContainerStyleState,
                contactDetailsStyleState: contactDetailsStyleState,
                contactTitleStyleState: contactTitleStyleState,
                contactTextStyleState: contactTextStyleState,
                contactTextTitleStyleState: contactTextTitleStyleState,
                contactTextMediumStyleState: contactTextMediumStyleState,
                contactTextDetailStyleState: contactTextDetailStyleState,
                copyrightContainerStyleState: copyrightContainerStyleState,
                copyrightTitleStyleState: copyrightTitleStyleState,
                menuSvgStyleState: menuSvgStyleState,
                menuBgSvgStyleState: menuBgSvgStyleState,
                logoSvgStyleState: logoSvgStyleState,
                googlePlayIconSvgStyleState: googlePlayIconSvgStyleState,
                detailControlsLeftSvgStyleState: detailControlsLeftSvgStyleState,
                detailControlsRightSvgStyleState: detailControlsRightSvgStyleState,
                setDetailControlsRightSvgStyleState: setDetailControlsRightSvgStyleState,
                detailControlsItemsContainerStyleState: detailControlsItemsContainerStyleState,
                itemsControlsLeftSvgStyleState: itemsControlsLeftSvgStyleState,
                setItemsControlsLeftSvgStyleState: setItemsControlsLeftSvgStyleState,
                itemsControlsRightSvgStyleState: itemsControlsRightSvgStyleState,
                setItemsControlsRightSvgStyleState: setItemsControlsRightSvgStyleState,
                privacyContainerContentStyleState: privacyContainerContentStyleState,
            }}
        >
            <RouterProvider router={router} />
        </AppContext.Provider>
    );
};

export default App;